import { render, staticRenderFns } from "./ServiceWorks.vue?vue&type=template&id=870f620a&scoped=true&"
import script from "./ServiceWorks.vue?vue&type=script&lang=js&"
export * from "./ServiceWorks.vue?vue&type=script&lang=js&"
import style0 from "./ServiceWorks.vue?vue&type=style&index=0&id=870f620a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870f620a",
  null
  
)

export default component.exports